import { GameTeamResultEnum } from 'queries';
import GameStatusText from './GameStatusText';
import styles from './styles/GameResultText.module.scss';
import cn from 'classnames';
import { ReactNode } from 'react';
import { POSTPONED } from 'constants/GameSecondaryStatuses';

export default function GameResultText({
  game,
  children
}: {
  game: {
    statusId: number;
    secondaryStatusId: number | undefined;
    date: string;
    featured:
      | {}
      | {
          result?: GameTeamResultEnum;
          scoreText?: string;
        };
    opponent:
      | {}
      | {
          scoreText?: string;
        };
  };
  children: ReactNode;
}) {
  return (
    <GameStatusText game={game}>
      {'result' in game.featured && game.featured.result !== null && (
        <span
          className={cn({
            [styles.Winner]: game.featured.result === GameTeamResultEnum.WIN,
            [styles.Loser]: game.featured.result === GameTeamResultEnum.LOSS
          })}
        >
          {game.featured.result === GameTeamResultEnum.WIN && 'W '}
          {game.featured.result === GameTeamResultEnum.LOSS && 'L '}
          {game.featured.result === GameTeamResultEnum.TIE && 'T '}
        </span>
      )}
      {'scoreText' in game.featured &&
      'scoreText' in game.opponent &&
      game.featured.scoreText &&
      game.opponent.scoreText &&
      game.secondaryStatusId !== POSTPONED
        ? `${game.featured.scoreText}-${game.opponent.scoreText}`
        : children}
    </GameStatusText>
  );
}
